import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Specialized layout for AI assistant experience with persistent sidebar
export default function AIAssistantLayout({ sidebar, children, className }) {
  return (
    <div className={classNames('h-full min-h-0 w-full overflow-hidden text-succession-text-primary bg-succession-bg-secondary', className)}>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-0 h-full min-h-0">
        <aside className="col-span-12 lg:col-span-3 h-full min-h-0 overflow-hidden border-r border-succession-border flex flex-col">{sidebar}</aside>
        <main className="lg:col-span-9 h-full min-h-0 overflow-hidden flex flex-col">{children}</main>
      </div>
    </div>
  );
}

AIAssistantLayout.propTypes = {
  sidebar: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
};


